import {Inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from '../shared/auth.service';
import {environment} from '../../environments/environment';
import {APP_BASE_HREF} from '@angular/common';

@Injectable()
export class QccGuard implements CanActivate {

  constructor(private Auth: AuthService,
              private Router: Router,
              @Inject(APP_BASE_HREF) private basePath: string) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!environment.flags.qccSubmittal) {
      location.replace(`${this.basePath}talent${state.url}`);
      return false;
    }

    const queryParams = {
      qccTrackingId: next.params['id'],
      qccOrderId: next.queryParams['order'],
      qccRating: next.queryParams['rating'],
      qccNeedsVerification: next.queryParams['needsVerification']
    };

    if (next.routeConfig.path === 'positions/:status/qcc') {
      if (!this.Auth.hasAuthentication()) {
        return true;
      } else {
        return this.Router.navigate(['/positions/working'], {queryParams: {...next.queryParams}}) && false;
      }
    }

    if (!this.Auth.hasAuthentication()) {
      return this.Router.navigate(['/positions/working/qcc'], {queryParams}) && false;
    }

    return this.Router.navigate(['/positions/working'], {queryParams}) && false;
  }
}
